<template>
  <RouterView :key="locale" :class="[mode]" />
</template>

<script setup lang="ts">
import { computed, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { RouterView } from 'vue-router';

import { usePermissionStore, useSettingStore, useUserStore } from '@/store';

const settingStore = useSettingStore();
const permissionStore = usePermissionStore();
const userStore = useUserStore();
onMounted(async () => {
  await userStore.getUserProfile();
  await permissionStore.initBaseRoutes();
});

const mode = computed(() => {
  return settingStore.displayMode;
});

const { locale } = useI18n();
</script>

<style lang="less" scoped>
#nprogress .bar {
  background: var(--td-brand-color) !important;
}
</style>
